import {
    GET_ACCOUNT_DATA,
    GET_ACCOUNT_DATA_SUCCESS,
    GET_ACCOUNT_DATA_FAILURE,
    SET_ACCOUNT_FILTER,
    SET_ACCOUNT_SEARCH,
    GET_FILTER_DATA,
    SET_UNSAVED_CHANGES,
    SET_COMMON_CANCEL,
    SET_SHOW_UNSAVED,
    SET_ISEDIT,
    SET_FAVORITE_SUCCESS,
    SET_CLEAR_FILTER,
    SET_CHECKBOX_VALUES,
    SET_SEARCH_PARAMS,
    SET_SHOW_EXPANDED_VIEW,
    SET_FILTER_VIEW,
    SET_VIEW_VALUES,
    SET_MORE_CLICK,
    GET_ACCOUNT_DETAILS,
    GET_ACCOUNT_DETAILS_SUCCESS,
    GET_ACCOUNT_DETAILS_FAILURE,
    SHOW_POPUP,
    UPDATE_ACCOUNT_DETAILS,
    UPDATE_ACCOUNT_DETAILS_SUCCESS,
    UPDATE_ACCOUNT_DETAILS_FAILURE,
    SELECTED_ACCOUNT_DETAILS,
    GET_PHYSICIAN_DETAILS,
    GET_PHYSICIAN_DETAILS_SUCCESS,
    SET_FAVORITE_PHYSICIAN_SUCCESS,
    GET_PHYSICIAN_DATA,
    GET_PHYSICIAN_DATA_SUCCESS,
    GET_PHYSICIAN_DATA_FAILURE,
    UPDATE_PHYSICIAN_NOTE,
    UPDATE_PHYSICIAN_NOTE_SUCCESS,
    UPDATE_PHYSICIAN_NOTE_FAILURE,
    SET_SEARCH_PARAMS_PHY,
    SET_PHYSICIAN_SEARCH,
    SET_TEMPLATE_SEARCH,
    SET_PHYSICIAN_FILTER,
    SET_PHYSICIAN_DETAIL_TAB,
    SET_ACCOUNT_DETAIL_TAB,
    CLOSE_PHYSICIAN_POPUP,
    SHOW_ACCOUNT_DETAIL_POPUP,
    GET_DISTRICT_SUCCESS,
    GET_DISTRICT_PHYSICIAN_SUCCESS,
    GET_TERRITORY_SUCCESS,
    GET_ACCOUNTS_SUCCESS,
    RESET_ACCOUNTS,
    RESET_TERRITORY,
    RESET_ACCOUNT_FILTER_STATE,
    RESTORE_ACCOUNT_FILTER_STATE,
    RESET_PHYSICIAN_FILTER_STATE,
    RESTORE_PHYSICIAN_FILTER_STATE,
    SET_APPLIED_VIEW_ACCOUNT_FILTER,
    SET_FILTER_TYPE,
    CLOSE_ACCOUNT_POPUP,
    SET_FAVORITE_ASSOCIATE_SUCCESS,
    SET_SPECIALITY_LIST,
    SET_ACCOUNT_FILTERS,
    SET_ACCOUNT_EXPAND_VIEW,
    SET_FILTER_PARAMS,
    SET_PHYSICIAN_ACCOUNT_FILTER,
    SET_ACCOUNT_FILTER_SNAPSHOT,
    SET_PHYSICIAN_FILTER_SNAPSHOT,
    SET_TEMPLATE_FILTER_SNAPSHOT,
    SET_SPECIALTY_FILTER_DATA,
    SET_SPECIALTY_EXPAND,
    SET_FAVORITE_ASSOCIATE_PHYSICIAN_SUCCESS,
    SET_POPUPCLOSE_FROM_HEADER,
    SET_CLEAR_PHYSICIAN_DETAILS,
    SET_SELECTED_PHYSICIAN,
    SET_SELECTED_OPTION,
    SET_LOCAL_EXPANDED_VIEW,
    SET_SURGERY_SCREEN,
    SET_EQUITY_SCREEN,
    SET_ACCOUNT_FAVORITE_PHYSICIAN_SUCCESS,
    SET_ACCOUNT_FAVORITE_PHYSICIAN_SEARCH_SUCCESS,
    GET_ACCOUNT_DATA_FROM_SEARCH_SUCCESS,
    GET_ACCOUNT_DATA_FROM_SEARCH,
    SET_PHYSICIAN_POPUPCLOSE_FROM_HEADER,
    GET_PHYSICIAN_FROM_SEARCH_DATA_SUCCESS,
    GET_PHYSICIAN_DATA_FROM_SEARCH,
    PHY_FILTER_OPEN,
    SET_APPLIED_VIEW_PHY_FILTER,
    GET_PHYSICIAN_DETAILS_FAILURE,
    SET_SHIP_TO_ADDRESS_EDIT,
    SET_ACCOUNT_FILTER_PARAM_VALUES,
    SET_PHYSICIAN_FILTER_PARAM_VALUES,
    SET_FILTER_PAGE,
    SET_FILTER_VIEW_PHYSICIAN,
    SET_FAVORITE_SEARCH_SUCCESS,
    SET_UNSAVED_CHANGES_PHYSICIAN,
    SET_SHOW_UNSAVED_PHYSICIAN,
    SET_SHOW_POPUP_PHYSICIAN,
    SET_FROM_ACCOUNT_SEARCH,
    GET_PHYSICIAN_FAV_STATUS_SUCCESS,
    CLOSE_POP_UP,
    GET_ACCOUNT_FAV_STATUS_SUCCESS,
    GET_ACCOUNTS_LIST_SUCCESS,
    RESET_ACCOUNTS_LIST,
    GET_SPECIALTY_FILTER_DATA_SUCCESS,
    SET_TEMPLATE_NOTE,
    SET_TEMPLATE_NOTE_ACCOUNT,
    SET_TEMPLATE_NOTE_CHANGE_PHYSICIAN,
    SET_TEMPLATE_NOTE_CHANGE_ACCOUNT,
    SET_ROUTE_PATH_FOR_ACCOUNT_UNSAVED_CHANGES_POP_UP,
    SET_ROUTE_PATH_FOR_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP,
    SET_ROUTE_PATH_FOR_PROXIES_UNSAVED_CHANGES_POP_UP,
    SET_ROUTE_PATH_FOR_PHYSICIANS_UNSAVED_CHANGES_POP_UP,
    SET_ACCOUNT_UNSAVED_CHANGES_POP_UP,
    SET_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP,
    SET_PHYSICIANS_UNSAVED_CHANGES_POP_UP,
    SET_PROXIES_UNSAVED_CHANGES_POP_UP,
    SET_FAVORITE
} from '../actions';
import { physicianDetailsTabs } from 'src/pages/more/pages/physicians/components/physicianDetails/physicianListConstants';
import { accDetailsTabs } from 'src/pages/more/pages/accounts/components/AccountDetails/accountListConstants';

const initialState = {
    loading: false,
    accountsData: [],
    accountDetails: {},
    accountUpdate: [],
    showPopup: false,
    popupClose: false,
    selectedAccount: [],
    statusCode: '',
    statusMessage: '',
    accountFilterOpen: false,
    accountSearchOpen: false,
    filterDataOpen: false,
    totalSearcResults: 0,
    accountFilterSnapshot: null,
    physicianFilterSnapshot: null,
    templateFilterSnapshot: null,
    commonUnsavedchanges: false,
    commonCancel: false,
    showUnsaved: false,
    isEdit: false,
    showAccountPopUp: false,
    showExpandedView: {
        districtView: true,
        territoryView: false,
        AccountView: false,
    },
    searchParams: {
        accountNameOrNumber: '',
        city: '',
        state: '',
    },
    filterAppliedView: [],
    moreClick: false,
    sortOrder: 'ASC',
    sortParam: 'locName',
    sortParamSearchResult: 'locName',
    sortOrderSearchResult: 'ASC',
    clearFilter: false,
    physicianDetails: {},
    physicianList: [],
    searchParamsPhy: {
        physicianName: '',
        hcpID: '',
        accountNameOrNumber: '',
        city: '',
        state: '',
    },
    physicianSearchOpen: false,
    templateSearchOpen: false,
    physicianFilterOpen: false,
    tabId: null,
    tabList: [],
    selectedTabId: physicianDetailsTabs()[0].id,
    tabListAccount: [],
    selectedTabIdAccount: accDetailsTabs()[0].id,
    districts: [],
    districtsPhysician: [],
    districtSuccess: true,
    districtSuccessPhysician: true,
    territories: [],
    territorySuccess: true,
    accounts: [],
    accountSuccess: true,
    // appliedQuickFilter: {},
    // appliedCategory: {},
    appliedView: {
        appliedDistrict: {},
        appliedTerritory: {},
        appliedAccount: {},
    },
    appliedViewPhy: {
        appliedDistrict: {},
        appliedTerritory: {},
        appliedAccount: {},
    },
    appliedFilter: {
        appliedOrderType: [],
        appliedOrderStatus: [],
    },
    // isQuickFilter: false,
    // categoryFilters: [],
    isFilterType: 'initial', //isFilter = initial, date, category, quickFilter, delete, AppliedView,ResetView, ResetFilter,pagination, pageSort, AppliedFilter
    physicianNotes: '',
    specialityList: [],
    // isFilterPopoverOpen: {
    //     isSet: false,
    //     isShowView: true,
    //     isShowFilter: false,
    // },
    physicianLoading: false,
    physicianDetailLoading: false,
    selectedAccountFilters: {},
    expandedAccountViews: {
        AccountView: false,
    },
    filterParams: {},
    selectedPhysicianFilters: {},
    specialityFilterData: [],
    showLocalExpandedFilter: { SpecialityFilter: false },
    statusMessagePhy: '',
    detailsLoading: false,
    selectedPhysician: {},
    selectedOption: {},
    showLocalExpandedView: {
        districtView: false,
        territoryView: false,
        accountView: false,
    },
    updateStatusMessage: '',
    surgeryTemplateOpen: false,
    equityTemplateOpen: false,
    fromAccountSearch: false,
    physicianPopupClose: false,
    getPhysicianFilter: false,
    shipToAddressEdit: false,
    accountFilterParamValues: '',
    physicianFilterParamValues: '',
    filterPage: false,
    commonUnsavedchangesPhysician: false,
    showUnsavedPhysician: false,
    showPopupPhy: false,
    fromAccountSearchNew: false,
    closePopUp: false,
    isFavoritePhysicianExists: '',
    isFavoriteAccountExists: '',
    filterAccounts: [],
    specialtyFilterPopulator: [],
    templateNotePhysician: '',
    templateNoteAccount: '',
    templateNoteChangeAccount: false,
    templateNoteChangePhysician: false,
    viewValuesPhysician: [],
    checkboxValues: [],
    routePathForAccountUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    routePathForProductGuideUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    routePathForProxiesUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    routePathForPhysiciansUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
    unsavedAccountChangesPopUp: false,
    unsavedProxiesChangesPopUp: false,
    unsavedProductGuideChangesPopUp: false,
    unsavedPhysiciansChangesPopUp: false,
};

// const resetPhysicianDetailHandler = () => {
//     return {
//         tabLists: initialState.tabLists,

//         selectedTabId: physicianDetailsTabs[0].id,
//     };
// };

const resetAccountDetailHandler = () => {
    return {
        tabListAccount: initialState.tabListAccount,

        selectedTabIdAccount: accDetailsTabs()[0].id,
        tabLists: initialState.tabList,

        selectedTabId: physicianDetailsTabs()[0].id,
    };
};
const updateFavourirePhysician = (action, prevState) => {
    const prevFilter = [...prevState];
    const updatedFilterIndex = prevFilter.findIndex(
        (x) => x.physicianId === action.physicianId
    );

    if (updatedFilterIndex >= -1) {
        const accTobeUpdate = { ...prevFilter[updatedFilterIndex] };
        accTobeUpdate.isFavorite = action.favValue;
        prevFilter[updatedFilterIndex] = accTobeUpdate;
    }

    return prevFilter;
};

const updateFavourireFromIcon = (action, prevState) => {
    const selectedTerritorycode = action.selectedTerritorycode;
    return prevState.map((item) => {
        if(item.districtAndTerritory?.[0]?.territoryCode === selectedTerritorycode && item.accountId === action.payload) {
            return {
                ...item,
                isFavorite: action.value
            };
        }
        return item;
    });
};

const updateFavourire = (action, prevState) => {
    const selectedTerritorycode = action.selectedTerritorycode;
        return prevState.map((item) => {
        if(item.districtAndTerritory?.[0]?.territoryCode === selectedTerritorycode && item.accountId === action.accountId){
            return {
                ...item,
                isFavorite: action.favValue
            };
        }
        return item;
    });
};

const updateCarrierNotes = (action) => {
    const prevFilter = action.carrierNotes;
    return prevFilter;
};

const updateCarrierpickup = (action) => {
    const prevFilter = action.carrierPickup;
    return prevFilter;
};
const updateCarrier = (action) => {
    const prevFilter = action.carrierLabel;
    return prevFilter;
};
const updateAccountNotes = (action) => {
    const prevFilter = action.accountNote;
    return prevFilter;
};
const updatePhysicianNotes = (action) => {
    const prevFilter = action.phyNotes;
    return prevFilter;
};
const AccountsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ACCOUNT_DATA:
            return {
                ...state,
                loading: true,
                totalSearcResults: 0,
                accountsData: [],
            };
        case SET_POPUPCLOSE_FROM_HEADER:
            return {
                ...state,
                popupClose: action.payload,
            };
        case SET_PHYSICIAN_POPUPCLOSE_FROM_HEADER:
            return {
                ...state,
                physicianPopupClose: action.payload,
            };
        case GET_ACCOUNT_DATA_FROM_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                accountsDataSearchResult: action.payload.accountsList,
                totalRecordsSearchResult: action.payload.accountsFetched,
                sortOrderSearchResult: action.payload.sortOrder,
                sortParamSearchResult: action.payload.sortParam,
                // totalSearcResults: action.payload.totalSearcResults,
            };
        case GET_ACCOUNT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                accountsData: action.payload.accountsList,
                totalRecords: action.payload.accountsFetched,
                sortOrder: action.payload.sortOrder,
                sortParam: action.payload.sortParam,
                fromAccountSearch: false,
                // totalSearcResults: action.payload.totalSearcResults,
            };
        case GET_ACCOUNT_DATA_FROM_SEARCH:
            return {
                ...state,
                fromAccountSearch: action.payload,
            };
        case GET_ACCOUNT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SET_ACCOUNT_FILTER:
            return {
                ...state,
                accountFilterOpen: action.payload,
            };
        case SET_UNSAVED_CHANGES:
            return {
                ...state,
                commonUnsavedchanges: action.payload,
            };
        case SET_COMMON_CANCEL:
            return {
                ...state,
                commonCancel: action.payload,
            };

        case SET_ACCOUNT_SEARCH:
            return {
                ...state,
                accountSearchOpen: action.payload,
            };
        case GET_FILTER_DATA:
            return {
                ...state,
                filterDataOpen: action.payload,
            };
        case SET_SHOW_UNSAVED:
            return {
                ...state,
                showUnsaved: action.payload,
            };
        case SET_ISEDIT:
            return {
                ...state,
                isEdit: action.payload,
            };

        case SET_FAVORITE: {
            const updatedFavList = updateFavourireFromIcon(
                action,
                state.accountsData
            );

            return {
                ...state,
                accountDetails: {
                    ...state.accountDetails,
                    isFavourite: !state.accountDetails.isFavourite,
                },
                accountsData: updatedFavList,
            };
        }

        case SET_FAVORITE_SUCCESS: {
            const updatedFavList = updateFavourire(
                action.payload,
                state.accountsData
            );

            return {
                ...state,
                accountDetails: {
                    ...state.accountDetails,
                    isFavourite: state.accountDetails.isFavourite,
                },
                accountsData: updatedFavList,
            };
        }
        case SET_FAVORITE_SEARCH_SUCCESS: {
            const updatedSearchFavList = updateFavourire(
                action.payload,
                state.accountsDataSearchResult
            );

            return {
                ...state,

                accountsDataSearchResult: updatedSearchFavList,
            };
        }
        case SET_FAVORITE_ASSOCIATE_SUCCESS: {
            const updatedAssociateList = updateFavourire(
                action.payload,
                state.physicianDetails.associatedAccounts
            );
            const updatedFavListHer = updateFavourire(
                action.payload,
                state.accountsData
            );
            return {
                ...state,
                physicianDetails: {
                    ...state.physicianDetails,
                    associatedAccounts: updatedAssociateList,
                },
                accountDetails: {
                    ...state.accountDetails,
                    isFavourite: !state.accountDetails.isFavourite,
                },

                accountsData: updatedFavListHer,
            };
        }
        case SET_SEARCH_PARAMS:
            return {
                ...state,
                searchParams: action.payload,
            };
        case SET_SHOW_EXPANDED_VIEW:
            return {
                ...state,
                showExpandedView: { ...action.payload },
            };
        case SET_FILTER_VIEW:
            return {
                ...state,
                filtervalues: action.payload,
            };
        case SET_FILTER_VIEW_PHYSICIAN:
            return {
                ...state,
                physicianFiltervalues: action.payload,
            };
        case SET_MORE_CLICK:
            return {
                ...state,
                moreClick: action.payload,
            };
        case SHOW_POPUP:
            return {
                ...state,
                showPopup: action.payload,
            };
        case SELECTED_ACCOUNT_DETAILS:
            return {
                ...state,
                selectedAccount: action.payload,
            };
        case GET_ACCOUNT_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                updateStatusMessage: '',
                accountDetails: {},
            };
        case GET_ACCOUNT_DETAILS_SUCCESS:
            // const updatedAccountNotes = updateAccountNotes(action.payload);
            return {
                ...state,
                detailsLoading: false,
                accountDetails: action.payload,
                //templateNoteAccount: '',
                // noteDetails: updatedAccountNotes,
                // tabId: 'accountDetails',
            };
        case GET_ACCOUNT_DETAILS_FAILURE:
            return {
                ...state,
                detailsLoading: false,
            };
        case UPDATE_ACCOUNT_DETAILS:
            return {
                ...state,
                loading: true,
            };
        case UPDATE_ACCOUNT_DETAILS_SUCCESS: {
            const updatedAccountNotess = updateAccountNotes(action.payload);
            const updatedCarrierNotes = updateCarrierNotes(
                action.payload,
                state.accountDetails?.accountDetails?.carrierNotes
            );
            const updateCarrierpickups = updateCarrierpickup(
                action.payload,
                state.accountDetails?.accountDetails?.carrierPickupNotifications
            );
            const updateCarrierData = updateCarrier(
                action.payload,
                state.accountDetails?.accountDetails?.carrierLabelDisplay
            );
            
            // Update ship to address with the request data if available
            const updatedShipToAddress = action.requestPayload?.defaultAPIShipMethods && state.accountDetails?.accountDetails?.defaultAPIShipMethods
                ? state.accountDetails.accountDetails.defaultAPIShipMethods.map((address) => {
                    const updatedAddress = action.requestPayload.defaultAPIShipMethods.find(
                        (reqAddr) => reqAddr.sapAccountId === address.accountNumber
                    );
                    if (updatedAddress) {
                        return {
                            ...address,
                            isTissueSelected: updatedAddress.defaultTissueShipTo,
                            isNonTissueSelected: updatedAddress.defaultNontissueShipTo,
                            isUnidRodSelected: updatedAddress.defaultUnidRodShipTo,
                        };
                    }
                    return address;
                })
                : state.accountDetails?.accountDetails?.defaultAPIShipMethods;
            
            return {
                ...state,
                loading: false,
                templateNoteAccount: '',
                updateStatusMessage: action.payload.statusMessage,
                accountDetails: {
                    ...state.accountDetails,
                    noteDetails: {
                        ...state.accountDetails?.accountDetails,
                        notes: updatedAccountNotess,
                    },
                    accountDetails: {
                        ...state.accountDetails?.accountDetails,
                        carrierNotes: updatedCarrierNotes,
                        carrier: updateCarrierData,
                        carrierPickupNotifications:
                            updateCarrierpickups === true ? 'Yes' : 'No',
                        defaultAPIShipMethods: updatedShipToAddress,
                    },
                },
            };
            // return {
            //     ...state,
            //     loading: false,
            //     accountUpdate: action.payload,
            // };
        }
        case UPDATE_ACCOUNT_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SET_CLEAR_FILTER:
            return {
                ...state,
                clearFilter: action.payload,
                accountFilterSnapshot: null,
                physicianFilterSnapshot: null,
                templateFilterSnapshot: null,
            };
        case GET_PHYSICIAN_DETAILS:
            return {
                ...state,

                physicianDetails: {},
                physicianDetailLoading: true,
            };
        case GET_PHYSICIAN_DETAILS_SUCCESS:
            return {
                ...state,
                physicianLoading: false,
                physicianDetails: action.payload,
                phyTabId: 'PhysicianDetails',
                // templateNotePhysician: '',
                physicianNotes: action.payload.notes,
                physicianDetailLoading: false,
            };
        case GET_PHYSICIAN_DETAILS_FAILURE:
            return {
                ...state,
                physicianDetailLoading: false,
            };
        case SET_FAVORITE_PHYSICIAN_SUCCESS: {
            const updateFavourirePhy = updateFavourirePhysician(
                action.payload,
                state.physicianList
            );

            return {
                ...state,

                physicianList: updateFavourirePhy,
            };
        }
        case SET_ACCOUNT_FAVORITE_PHYSICIAN_SEARCH_SUCCESS: {
            const updateFavourirePhysicianSearch = updateFavourirePhysician(
                action.payload,
                state.physicianListSearch
            );

            return {
                ...state,

                physicianListSearch: updateFavourirePhysicianSearch,
            };
        }
        case SET_ACCOUNT_FAVORITE_PHYSICIAN_SUCCESS: {
            const updateassociatedFavourire = updateFavourirePhysician(
                action.payload,
                state.accountDetails.associatedPhysicians
            );

            return {
                ...state,

                physicianDetails: {
                    ...state.physicianDetails,
                    physicianDetails: {
                        ...state.physicianDetails.physicianDetails,
                        isFavorite:
                            !state.physicianDetails.physicianDetails.isFavorite,
                    },
                },
                accountDetails: {
                    ...state.accountDetails,
                    associatedPhysicians: updateassociatedFavourire,
                },
            };
        }
        case SET_FAVORITE_ASSOCIATE_PHYSICIAN_SUCCESS: {
            const updateassociatedFavourirePhy = updateFavourirePhysician(
                action.payload,
                state.accountDetails.associatedPhysicians
            );
            const updateFavourirePhysicianNew = updateFavourirePhysician(
                action.payload,
                state.physicianList
            );
            return {
                ...state,
                accountDetails: {
                    ...state.accountDetails,
                    associatedPhysicians: updateassociatedFavourirePhy,
                },
                physicianDetails: {
                    ...state.physicianDetails,
                    // physicianDetails: {
                    //     ...state.physicianDetails.physicianDetails,
                    //     isFavorite:
                    //         !state.physicianDetails.physicianDetails.isFavorite,
                    // },
                    isFavorite: !state.physicianDetails.isFavorite,
                },

                physicianList: updateFavourirePhysicianNew,
            };
        }
        case GET_PHYSICIAN_DATA:
            return {
                ...state,
                physicianLoading: true,
            };

        case SET_CLEAR_PHYSICIAN_DETAILS:
            return {
                ...state,
                physicianDetails: {},
            };
        case GET_PHYSICIAN_DATA_SUCCESS:
            return {
                ...state,
                physicianLoading: false,
                physicianList: action.payload.physicianDetails,
                totalResults: action.payload.totalResults,
                sortOrder: action.payload.sortOrder,
                sortParam: action.payload.sortParam,

                statusMessagePhy: action.payload.statusMessage,
            };
        case GET_PHYSICIAN_DATA_FAILURE:
            return {
                ...state,
                physicianLoading: false,
            };
        case UPDATE_PHYSICIAN_NOTE:
            return {
                ...state,
                physicianLoading: true,
            };
        case UPDATE_PHYSICIAN_NOTE_SUCCESS: {
            const updatePhyNotes = updatePhysicianNotes(action.payload);
            return {
                ...state,
                physicianLoading: false,
                physicianNotes: updatePhyNotes,
                templateNotePhysician: '',
                phyTabId: 'notes',
            };
        }
        case UPDATE_PHYSICIAN_NOTE_FAILURE:
            return {
                ...state,
                physicianLoading: false,
            };

        case SET_SEARCH_PARAMS_PHY:
            return {
                ...state,
                searchParamsPhy: action.payload,
            };
        case SET_PHYSICIAN_SEARCH:
            return {
                ...state,
                physicianSearchOpen: action.payload,
            };
        case SET_TEMPLATE_SEARCH:
            return {
                ...state,
                templateSearchOpen: action.payload,
            };
        case SET_PHYSICIAN_FILTER:
            return {
                ...state,
                physicianFilterOpen: action.payload,
            };
        case SET_PHYSICIAN_DETAIL_TAB:
            return {
                ...state,
                ...action.data,
            };
        case CLOSE_PHYSICIAN_POPUP: {
            const resetPhysicianDetail = resetAccountDetailHandler();

            return {
                ...state,
                ...action.payload,
                ...resetPhysicianDetail,
            };
        }
        case SHOW_ACCOUNT_DETAIL_POPUP:
            return {
                ...state,
                showAccountPopUp: action.payload,
            };
        case CLOSE_ACCOUNT_POPUP: {
            const resetAccountDetail = resetAccountDetailHandler();

            return {
                ...state,
                ...action.payload,
                ...resetAccountDetail,
            };
        }
        case SET_ACCOUNT_DETAIL_TAB:
            return {
                ...state,
                ...action.data,
            };
        case GET_DISTRICT_SUCCESS:
            return {
                ...state,
                ...action.data,
                districts: Array.isArray(action.data?.districts)
                    ? action.data.districts
                    : [],
                districtSuccess:
                    action.data.statusCode === '10001' ? true : false,
            };
        case GET_DISTRICT_PHYSICIAN_SUCCESS:
            return {
                ...state,
                ...action.data,
                districtSuccessPhysician:
                    action.data.statusCode === '10001' ? true : false,
            };
        case GET_TERRITORY_SUCCESS:
            return {
                ...state,
                //...action.data,
                territories: Array.isArray(action.data?.territories)
                    ? action.data.territories.filter(
                          (item) => item.terrirotryCode !== 'GSE'
                      )
                    : [],
                territorySuccess:
                    action.data.statusCode === '10001' ? true : false,
            };
        case GET_ACCOUNTS_SUCCESS:
            return {
                ...state,
                accounts: action.data.accounts || [],
                statusCode: action.data.statusCode,
                accountSuccess:
                    action.data.statusCode === '10001' ? true : false,
            };
        case RESET_TERRITORY:
            return {
                ...state,
                territories: [],
                territorySuccess: true,
            };
        case RESET_ACCOUNTS:
            return {
                ...state,
                accounts: [],
                accountSuccess: true,
            };
        case RESET_ACCOUNT_FILTER_STATE:
            return {
                ...state,
                accountFilterSnapshot: null,
                selectedAccountFilters: {},
                filterParams: {},
                accountFilterParamValues: '',
                filtervalues: [],
                appliedView: {
                    appliedDistrict: {},
                    appliedTerritory: {},
                    appliedAccount: {},
                },
                appliedFilter: {},
                accounts: [],
                accountSuccess: true,
                territories: [],
                territorySuccess: true,
            };
        case RESTORE_ACCOUNT_FILTER_STATE:
            return {
                ...state,
                accountFilterSnapshot: action.payload.accountFilterSnapshot,
                selectedAccountFilters: action.payload.selectedAccountFilters,
                filterParams: action.payload.filterParams,
                accountFilterParamValues: action.payload.accountFilterParamValues,
                filtervalues: action.payload.filtervalues,
                appliedView: action.payload.appliedView,
                appliedFilter: action.payload.appliedFilter,
            };
        case RESET_PHYSICIAN_FILTER_STATE:
            return {
                ...state,
                physicianFilterSnapshot: null,
                selectedPhysicianFilters: {},
                physicianFilterParamValues: '',
                physicianFiltervalues: [],
                appliedViewPhy: {
                    appliedDistrict: {},
                    appliedTerritory: {},
                    appliedAccount: {},
                },
                appliedFilterPhy: {},
                viewValuesPhysician: [],
                checkboxValues: [],
                getPhysicianFilter: false,
            };
        case RESTORE_PHYSICIAN_FILTER_STATE:
            return {
                ...state,
                physicianFilterSnapshot: action.payload.physicianFilterSnapshot,
                selectedPhysicianFilters: action.payload.selectedPhysicianFilters,
                physicianFilterParamValues: action.payload.physicianFilterParamValues,
                physicianFiltervalues: action.payload.physicianFiltervalues,
                appliedViewPhy: action.payload.appliedViewPhy,
                appliedFilterPhy: action.payload.appliedFilterPhy,
                viewValuesPhysician: action.payload.viewValuesPhysician,
                checkboxValues: action.payload.checkboxValues,
                getPhysicianFilter: action.payload.getPhysicianFilter,
            };
        case RESET_ACCOUNTS_LIST:
            return {
                ...state,
                filterAccounts: [],
                accountFilterSuccess: true,
            };

        case SET_APPLIED_VIEW_ACCOUNT_FILTER:
            return {
                ...state,
                appliedView: { ...action.payload.appliedView },
                appliedFilter: { ...action.payload.appliedFilter },
            };
        case SET_APPLIED_VIEW_PHY_FILTER:
            return {
                ...state,
                appliedViewPhy: { ...action.payload.appliedView },
                appliedFilterPhy: { ...action.payload.appliedFilter },
            };
        case SET_FILTER_TYPE:
            return {
                ...state,
                isFilterType: action.payload,
            };
        case SET_SPECIALITY_LIST:
            return {
                ...state,
                specialityList: action.payload,
            };
        case SET_ACCOUNT_FILTERS:
            return {
                ...state,
                selectedAccountFilters: action.payload,
            };
        case SET_ACCOUNT_FILTER_SNAPSHOT:
            return {
                ...state,
                accountFilterSnapshot: action.payload,
            };
        case SET_PHYSICIAN_FILTER_SNAPSHOT:
            return {
                ...state,
                physicianFilterSnapshot: action.payload,
            };
        case SET_TEMPLATE_FILTER_SNAPSHOT:
            return {
                ...state,
                templateFilterSnapshot: action.payload,
            };
        case SET_ACCOUNT_EXPAND_VIEW:
            return {
                ...state,
                expandedAccountViews: action.payload,
            };
        case SET_FILTER_PARAMS:
            return {
                ...state,
                filterParams: action.payload,
            };
        case SET_PHYSICIAN_ACCOUNT_FILTER:
            return {
                ...state,
                selectedPhysicianFilters: action.payload,
            };
        case SET_SPECIALTY_FILTER_DATA:
            return {
                ...state,
                specialityFilterData: action.payload,
            };
        case SET_SPECIALTY_EXPAND:
            return {
                ...state,
                showLocalExpandedFilter: action.payload,
            };
        case SET_SELECTED_PHYSICIAN:
            return {
                ...state,
                selectedPhysician: action.payload,
            };
        case SET_SELECTED_OPTION:
            return {
                ...state,
                selectedOption: action.payload,
            };
        case SET_LOCAL_EXPANDED_VIEW:
            return {
                ...state,
                showLocalExpandedView: action.payload,
            };

        case SET_SURGERY_SCREEN:
            return {
                ...state,
                surgeryTemplateOpen: action.payload,
            };
        case SET_SHIP_TO_ADDRESS_EDIT:
            return {
                ...state,
                shipToAddressEdit: action.payload,
            };

        case SET_EQUITY_SCREEN:
            return {
                ...state,
                equityTemplateOpen: action.payload,
            };
        case GET_PHYSICIAN_DATA_FROM_SEARCH:
            return {
                ...state,
                fromPhysicianSearch: action.payload,
            };
        case GET_PHYSICIAN_FROM_SEARCH_DATA_SUCCESS:
            return {
                ...state,
                physicianLoading: false,
                physicianListSearch: action.payload.physicianDetails,
                totalResultsSearch: action.payload.totalResults,
                sortOrderSearch: action.payload.sortOrder,
                sortParamSearch: action.payload.sortParam,

                statusMessagePhySearch: action.payload.statusMessage,
            };
        case PHY_FILTER_OPEN:
            return {
                ...state,
                getPhysicianFilter: action.payload,
            };
        case SET_ACCOUNT_FILTER_PARAM_VALUES:
            return {
                ...state,
                accountFilterParamValues: action.payload,
            };
        case SET_PHYSICIAN_FILTER_PARAM_VALUES:
            return {
                ...state,
                physicianFilterParamValues: action.payload,
            };
        case SET_FILTER_PAGE:
            return {
                ...state,
                filterPage: action.payload,
            };
        case SET_UNSAVED_CHANGES_PHYSICIAN:
            return {
                ...state,
                commonUnsavedchangesPhysician: action.payload,
            };

        case SET_SHOW_UNSAVED_PHYSICIAN:
            return {
                ...state,
                showUnsavedPhysician: action.payload,
            };
        case SET_SHOW_POPUP_PHYSICIAN:
            return {
                ...state,
                showPopupPhy: action.payload,
            };
        case SET_FROM_ACCOUNT_SEARCH:
            return {
                ...state,
                fromAccountSearchNew: action.payload,
            };
        case CLOSE_POP_UP:
            return {
                ...state,
                closePopUp: action.payload,
            };
        case GET_PHYSICIAN_FAV_STATUS_SUCCESS:
            return {
                ...state,
                isFavoritePhysicianExists:
                    action.payload.isFavoritePhysicianExists,
            };
        case GET_ACCOUNT_FAV_STATUS_SUCCESS:
            return {
                ...state,
                isFavoriteAccountExists:
                    action.payload.isFavoriteAccountsExists,
            };
        case GET_ACCOUNTS_LIST_SUCCESS:
            return {
                ...state,
                filterAccounts: action.payload.selectedAccountsList,
                accountFilterSuccess:
                    action.payload.statusCode === '10001' ? true : false,
            };
        case GET_SPECIALTY_FILTER_DATA_SUCCESS:
            return {
                ...state,

                specialtyFilterPopulator:
                    action.payload.specialtyFilterPopulator,
            };
        case SET_TEMPLATE_NOTE:
            return {
                ...state,
                templateNotePhysician: action.payload,
            };
        case SET_TEMPLATE_NOTE_ACCOUNT:
            return {
                ...state,
                templateNoteAccount: action.payload,
            };
        case SET_TEMPLATE_NOTE_CHANGE_ACCOUNT:
            return {
                ...state,
                templateNoteChangeAccount: action.payload,
            };
        case SET_TEMPLATE_NOTE_CHANGE_PHYSICIAN:
            return {
                ...state,
                templateNoteChangePhysician: action.payload,
            };
        case SET_VIEW_VALUES:
            return {
                ...state,
                viewValuesPhysician: action.payload,
            };
        case SET_CHECKBOX_VALUES:
            return {
                ...state,
                checkboxValues: action.payload,
            };
        case SET_ACCOUNT_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedAccountChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_ACCOUNT_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForAccountUnsavedChangesPopUp: action.payload,
            };
        case SET_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedProductGuideChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForProductGuideUnsavedChangesPopUp: action.payload,
            };
        case SET_PROXIES_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedProxiesChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_PROXIES_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForProxiesUnsavedChangesPopUp: action.payload,
            };
        case SET_PHYSICIANS_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedPhysiciansChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_PHYSICIANS_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForPhysiciansUnsavedChangesPopUp: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default AccountsReducer;
